import listenForKeys from "../../../functions/KeyboardCommands";

export default {
  data() {
    return {
      navDisplayHideRules: [],
      snackbarHideRules: [],
    };
  },
  created() {
    this.setRules();
    listenForKeys(this);
  },

  methods: {
    setRules() {
      this.snackbarHideRules = [
        {
          type: "boolean",
          value: this.$store.state.isSmallScreen,
        },
        {
          type: "boolean",
          value: this.$store.state.isMobile,
        },
        {
          type: "boolean",
          value: this.$store.state.isTabletPortrait,
        },
        /*{
          type: "url",
          url: `/${this.$store.state.company}`,
          exact: true,
        },
        {
          type: "url",
          url: `/${this.$store.state.company}/`,
          exact: true,
        },
        {
          type: "url",
          url: `/${this.$store.state.company}/userforget`,
          exact: true,
        },
        {
          type: "url",
          url: `/${this.$store.state.company}/reset`,
          exact: true,
        },
        {
          type: "url",
          url: `/${this.$store.state.company}/transfer/`,
          exact: false,
        },
        {
          type: "url",
          url: `/404`,
          exact: false,
        },
        {
          type: "url",
          url: `/pwa`,
          exact: true,
        },
        {
          type: "url",
          url: `/`,
          exact: true,
        },*/
      ];

      this.navDisplayHideRules = [
        {
          type: "boolean",
          value: this.$store.state.isMobile,
        },
        {
          type: "boolean",
          value: this.$store.state.isTabletPortrait,
        },
        {
          type: "url",
          url: `/${this.$store.state.company}`,
          exact: true,
        },
        {
          type: "url",
          url: `/${this.$store.state.company}/`,
          exact: true,
        },
        {
          type: "url",
          url: `/${this.$store.state.company}/userforget`,
          exact: true,
        },
        {
          type: "url",
          url: `/${this.$store.state.company}/reset`,
          exact: true,
        },
        {
          type: "url",
          url: `/${this.$store.state.company}/transfer/`,
          exact: false,
        },
        {
          type: "url",
          url: `/404`,
          exact: false,
        },
        {
          type: "url",
          url: `/pwa`,
          exact: true,
        },
        {
          type: "url",
          url: `/${this.$store.state.company}/invite-accepted`,
          exact: true,
        },
        {
          type: "url",
          url: `/`,
          exact: true,
        },
      ];
    },
    displaySnackbar() {
      return this.checkRules(this.snackbarHideRules);
    },
    displayMainNav() {
      return this.checkRules(this.navDisplayHideRules);
    },

    checkRules(rules) {
      let canDisplay = true;
      rules.forEach((rule) => {
        switch (rule.type) {
          case "boolean":
            if (rule.value) {
              //is true so cannot display
              canDisplay = false;
            }
            break;

          case "url":
            if (rule.exact) {
              if (this.$route.path === rule.url) {
                canDisplay = false;
              }
            } else {
              if (this.$route.path.indexOf(rule.url) !== -1) {
                canDisplay = false;
              }
            }
            break;
        }
      });

      return canDisplay;
    },
    checkUrlForBigChanges(newUrl, oldUrl) {
      return newUrl.params.id === oldUrl.params.id;
    },
  },

  watch: {
    $route(newUrl, oldUrl) {
      //update rules in case of company change
      if (oldUrl.params.company !== newUrl.params.company) {
        this.setRules();
      }

      //wipe the selected items on change if transfer mode is inactive
      //
      if (
        !this.$store.state.isTransfering &&
        !this.checkUrlForBigChanges(newUrl, oldUrl)
      ) {
        this.$store.state.transferItems = {
          selectedFiles: [],
          selectedFolders: [],
          collection: {},
        };
      }
    },
    "$store.state.isMobile"() {
      this.setRules();
    },
    "$store.state.isTabletPortrait"() {
      this.setRules();
    },
    "$store.state.isSmallScreen"() {
      this.setRules();
    },
  },
};
